<template>
  <span>
    <v-navigation-drawer
      v-if="user"
      v-model="drawer"
      floating
      clipped
      fixed
      app
    >
      <v-list dense>
        <v-list-tile
          v-if="user && isEmailVerified"
          style="margin-bottom:20px;margin-top:20px;"
        >
          <v-list-tile-content>
            <v-list-tile-title>Account</v-list-tile-title>
            <v-list-tile-sub-title>{{ user.email }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <ListItem text="Home" :to="{ name: 'home' }" />
        <ListItem
          v-for="entry in projects"
          :key="entry[0]"
          :text="entry[1].name"
          :iconColor="entry[1].color"
          icon="fas fa-square-full"
          :to="{ name: 'projectView', params: { projectId: entry[0] } }"
        />
        <v-divider></v-divider>
        <ListItem text="About" :to="{ name: 'about' }" />
        <ListItem v-if="user" text="Feedback" :to="{ name: 'feedback' }" />
        <v-list-tile v-if="user" @click="signOut">
          <v-list-tile-content>
            <v-list-tile-title>Sign Out</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <!-- FAB has z-idnex of 4 -->
    <v-toolbar flat fixed clipped-left app style="z-index:5">
      <v-toolbar-side-icon
        v-if="user"
        @click="toggleNavDrawer"
      ></v-toolbar-side-icon>
      <router-link :to="{ name: 'home' }">
        <v-toolbar-title class="headline">
          <span class="font-weight-light display-font">Volition.Page</span>
          <v-chip
            :class="{ 'hidden-sm-and-down': user && !isEmailVerified }"
            outline
            label
            small
            >ALPHA</v-chip
          >
        </v-toolbar-title>
      </router-link>
      <v-spacer></v-spacer>
      <v-layout
        shrink
        v-if="user && !isEmailVerified"
        align-center
        justify-center
      >
        <v-btn small color="primary" :to="{ name: 'signUp' }">
          Finish Sign Up
        </v-btn>
        <v-layout
          shrink
          column
          :class="{ 'hidden-sm-and-down': user && !isEmailVerified }"
        >
          <v-flex shrink class="font-weight-black">
            Trial Account
          </v-flex>
          <v-flex
            shrink
            :class="{ 'hidden-md-and-down': user && !isEmailVerified }"
          >
            Data will be lost when sign out
          </v-flex>
        </v-layout>
      </v-layout>
    </v-toolbar>
  </span>
</template>

<script>
import { mapState } from "vuex";
import ListItem from "./ListItem";
export default {
  components: {
    ListItem
  },
  data() {
    return {
      drawer: false,
      isEmailVerified: true,
      userCheck: undefined
    };
  },
  methods: {
    toggleNavDrawer() {
      this.drawer = !this.drawer;
    },
    async signOut() {
      await this.auth.signOut();
      this.$router.push({ name: "about" });
    },
    installChecker() {
      this.removeChecker();
      this.isEmailVerified = true;
      this.userCheck = setInterval(() => {
        if (this.user) {
          this.isEmailVerified = this.user.emailVerified;
          if (this.isEmailVerified) {
            this.removeChecker();
          }
        }
      }, 500);
    },
    removeChecker() {
      if (this.userCheck !== undefined) {
        clearInterval(this.userCheck);
      }
    }
  },
  mounted() {
    this.installChecker();
  },
  watch: {
    user(value) {
      if (value != undefined) {
        this.installChecker();
      } else {
        this.removeChecker();
      }
    }
  },
  beforeDestroy() {
    this.removeChecker();
  },
  computed: {
    ...mapState(["user", "auth", "projectReader"]),
    projects() {
      return Object.entries(this.projectReader.data).sort((a, b) => {
        return a[1].index - b[1].index;
      });
    }
  }
};
</script>

<style scoped>
span >>> .v-navigation-drawer:not(.v-navigation-drawer--is-mobile) {
  background-color: #fafafa;
}
</style>
